import React, { useEffect } from 'react';

const ImpressumPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#FAFBFC] to-white pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 fade-in">
          <h1 className="text-5xl md:text-6xl font-bold text-[#0A2846] mb-8 tracking-tight">
            Impressum
          </h1>
          <div 
            className="w-32 h-2 mx-auto rounded-full"
            style={{ 
              background: 'linear-gradient(90deg, #D4AF37 0%, #FFD700 50%, #F4D03F 100%)',
              boxShadow: '0 6px 20px rgba(212, 175, 55, 0.4)'
            }} 
          />
        </div>

        {/* Content */}
        <div className="bg-white p-12 rounded-2xl shadow-elegant space-y-10">
          {/* Angaben gemäß § 5 TMG */}
          <div>
            <h2 className="text-2xl font-bold text-[#0A2846] mb-4">Angaben gemäß § 5 TMG</h2>
            <p className="text-[#1F2937] leading-relaxed">
              <strong className="block mb-2">PROBAV Gebäudereinigung</strong>
              Inhaber: Baver Güzel<br />
              Maria-Terwiel-Str. 7<br />
              51377 Leverkusen
            </p>
          </div>

          {/* Kontakt */}
          <div>
            <h2 className="text-2xl font-bold text-[#0A2846] mb-4">Kontakt</h2>
            <p className="text-[#1F2937] leading-relaxed">
              <strong>E-Mail:</strong> <a href="mailto:kontakt@probav-reinigung.de" className="text-[#D4AF37] hover:underline">kontakt@probav-reinigung.de</a><br />
              <strong>Telefon:</strong> <a href="tel:+491701247477" className="text-[#D4AF37] hover:underline">+49 170 1247477</a>
            </p>
          </div>

          {/* Umsatzsteuer */}
          <div>
            <h2 className="text-2xl font-bold text-[#0A2846] mb-4">Umsatzsteuer</h2>
            <p className="text-[#1F2937] leading-relaxed">
              Gemäß § 19 UStG wird keine Umsatzsteuer erhoben.
            </p>
          </div>

          {/* Verantwortlich für den Inhalt */}
          <div>
            <h2 className="text-2xl font-bold text-[#0A2846] mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p className="text-[#1F2937] leading-relaxed">
              Baver Güzel<br />
              Maria-Terwiel-Str. 7<br />
              51377 Leverkusen
            </p>
          </div>

          {/* Haftungsausschluss */}
          <div>
            <h2 className="text-2xl font-bold text-[#0A2846] mb-4">Haftungsausschluss</h2>
            <p className="text-[#1F2937] leading-relaxed">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. 
              Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
            </p>
          </div>

          {/* Datenschutzerklärung */}
          <div className="border-t-2 border-[#D4AF37]/20 pt-10">
            <h2 className="text-3xl font-bold text-[#0A2846] mb-8">Datenschutzerklärung</h2>

            <div className="space-y-8">
              {/* 1. Verantwortlicher */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">1. Verantwortlicher</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  PROBAV Gebäudereinigung<br />
                  Inhaber: Baver Güzel<br />
                  Maria-Terwiel-Str. 7, 51377 Leverkusen<br />
                  E-Mail: <a href="mailto:kontakt@probav-reinigung.de" className="text-[#D4AF37] hover:underline">kontakt@probav-reinigung.de</a><br />
                  Telefon: +49 170 1247477
                </p>
              </div>

              {/* 2. Allgemeines */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">2. Allgemeines zur Datenverarbeitung</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Personenbezogene Daten werden vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften (DSGVO, BDSG) behandelt.
                </p>
              </div>

              {/* 3. Erhebung und Speicherung */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">3. Erhebung und Speicherung personenbezogener Daten</h3>
                <p className="text-[#1F2937] leading-relaxed mb-3">
                  Wir erheben personenbezogene Daten nur, wenn Sie uns diese freiwillig mitteilen, z. B. durch eine E-Mail-Anfrage oder über ein Kontaktformular.
                </p>
                <p className="text-[#1F2937] leading-relaxed mb-2">Zu den verarbeiteten Daten können gehören:</p>
                <ul className="list-disc list-inside text-[#1F2937] ml-4 space-y-1">
                  <li>Name, Adresse</li>
                  <li>Telefonnummer, E-Mail-Adresse</li>
                  <li>Nachrichtentext oder Angebotsanfragen</li>
                </ul>
                <p className="text-[#1F2937] leading-relaxed mt-3">
                  Diese Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.
                </p>
              </div>

              {/* 4. Rechtsgrundlage */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">4. Rechtsgrundlage der Verarbeitung</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung oder vorvertragliche Maßnahmen) oder Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
                </p>
              </div>

              {/* 5. Weitergabe */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">5. Weitergabe von Daten</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, es sei denn, sie ist gesetzlich vorgeschrieben oder zur Vertragserfüllung erforderlich (z. B. an Steuerberater, wenn nötig).
                </p>
              </div>

              {/* 6. Speicherdauer */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">6. Dauer der Speicherung</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  Wir speichern personenbezogene Daten nur so lange, wie es für die Bearbeitung Ihrer Anfrage oder zur Einhaltung gesetzlicher Aufbewahrungsfristen erforderlich ist.
                </p>
              </div>

              {/* 7. Rechte */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">7. Ihre Rechte</h3>
                <p className="text-[#1F2937] leading-relaxed mb-2">Sie haben jederzeit das Recht auf:</p>
                <ul className="list-disc list-inside text-[#1F2937] ml-4 space-y-1">
                  <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
                  <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                  <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
                  <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                  <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                  <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                </ul>
                <p className="text-[#1F2937] leading-relaxed mt-3">
                  Bitte richten Sie Ihre Anfragen an: <a href="mailto:kontakt@probav-reinigung.de" className="text-[#D4AF37] hover:underline">kontakt@probav-reinigung.de</a>
                </p>
              </div>

              {/* 8. Sicherheit */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">8. Sicherheit</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  Wir treffen angemessene technische und organisatorische Maßnahmen, um Ihre Daten vor Verlust, Missbrauch oder unbefugtem Zugriff zu schützen.
                </p>
              </div>

              {/* 9. Server-Logfiles */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">9. Server-Logfiles</h3>
                <p className="text-[#1F2937] leading-relaxed mb-2">
                  Beim Besuch dieser Website werden automatisch Informationen in sogenannten Server-Logfiles gespeichert. Dazu gehören:
                </p>
                <ul className="list-disc list-inside text-[#1F2937] ml-4 space-y-1">
                  <li>Browsertyp und -version</li>
                  <li>Verwendetes Betriebssystem</li>
                  <li>Referrer URL</li>
                  <li>IP-Adresse (anonymisiert)</li>
                  <li>Datum und Uhrzeit des Zugriffs</li>
                </ul>
                <p className="text-[#1F2937] leading-relaxed mt-3">
                  Diese Daten dienen ausschließlich der technischen Sicherheit und werden nicht mit anderen Datenquellen zusammengeführt.
                </p>
              </div>

              {/* 10. Cookies */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">10. Cookies und Analyse-Tools</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  Unsere Website verwendet standardmäßig keine Tracking- oder Analyse-Tools. Falls zukünftig Analyse- oder Statistikdienste (z. B. Google Analytics) eingesetzt werden, wird darüber gesondert informiert und Ihre Einwilligung eingeholt.
                </p>
              </div>

              {/* 11. Kontaktformular */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">11. Kontaktformular</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
              </div>

              {/* 12. SSL */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">12. SSL-Verschlüsselung</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL-Verschlüsselung.
                </p>
              </div>

              {/* 13. Aktualität */}
              <div>
                <h3 className="text-xl font-semibold text-[#0A2846] mb-3">13. Aktualität und Änderung dieser Datenschutzerklärung</h3>
                <p className="text-[#1F2937] leading-relaxed">
                  Diese Datenschutzerklärung ist aktuell gültig und hat den Stand November 2025. Wir behalten uns vor, diese Erklärung bei Bedarf zu aktualisieren.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
